import { FORM_FIELD_TYPE } from '../../../constants/common';

const KEY_MAP = {
  farm_id: 'Farm',
  collectionIds: 'Groups',
  identifier: 'Group ID',
  animals_count: 'No. of Livestock in Group',
  name: 'Group Name',
  main_type: 'Group Type'
};

export const GROUP_EDIT_FIELDS = [
  {
    id: 'farm_id',
    editable: true,
    type: FORM_FIELD_TYPE.SELECT,
    name: KEY_MAP['farm_id']
  },
  {
    id: 'animals_count',
    editable: false,
    type: FORM_FIELD_TYPE.INPUT,
    name: KEY_MAP['animals_count']
  }
];

export const commonColumnProperties = {
  ellipsis: true,
  sortDirections: ['ascend', 'descend']
};
